/* eslint-disable import/prefer-default-export */
import Vue from 'vue'
import {
	store
} from '@/store/store'
import url from '@/services/ApiServices/apiUrls'
import * as productApi from './productApi'
import router from '../../router'

export const cartApis = new Vue({
	methods: {
		insertCart (cartDetails) {
			const cartProductDetails = JSON.parse(JSON.stringify(store.getters['cart/getOrderCart']))
			const getChoosenCountry = JSON.parse(JSON.stringify(store.getters['siteData/getSelectedCountryCode']))
			return new Promise((resolve, reject) => {
				this.$http.post(url.insertCartUrl + getChoosenCountry, cartProductDetails)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		getCart () {
			return new Promise((resolve, reject) => {
				this.$http.get(url.getCartUrl)
					.then((res) => {
						const cartProducts = JSON.parse(JSON.stringify(store.getters['cart/getCartProducts']))
						if (res.data && res.data.length > 0) {
							res.data.forEach((product) => {
								const index = cartProducts.findIndex(prod => prod.product_id === product.product_id)
								if (index === -1) {
									product.timestamp = new Date().getTime()
									productApi.assignVendorInventoryAndPromotionalPrices(product)
									store.dispatch('cart/addToCart', product)
								} else if (product.timestamp && product.timestamp > cartProducts[index].timestamp) {
									cartProducts[index] = product
								}
							})
						}
						cartApis.updateCart()
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		updateCart () {
			store.dispatch('cart/emptyLocalCart')
			let cartProductDetails = JSON.parse(JSON.stringify(store.getters['cart/getOrderCart']))
			if (store.getters['buynow/getOrderBuyNowProduct'].length > 0) {
				cartProductDetails = JSON.parse(JSON.stringify(store.getters['buynow/getOrderBuyNowProduct']))
			}
			return new Promise((resolve, reject) => {
				this.$http.post(url.updateCartUrl, cartProductDetails)
					.then((res) => {
						if (store.getters['buynow/getOrderBuyNowProduct'].length > 0) {
							// store.dispatch('buynow/deleteFromBuyNow');
							if (res.data && res.data.length > 0) {
								store.dispatch('buynow/addToBuyNow', res.data[0])
							}
						} else {
							store.dispatch('cart/emptyCart')
							const cartProductsData = JSON.parse(JSON.stringify(store.getters['cart/getCartProducts']))
							if (res.data && res.data.length > 0) {
								res.data.forEach((product) => {
									const index = cartProductsData.findIndex(prod =>
										prod.product_id === product.product_id)
									if (index === -1) {
										product.timestamp = new Date().getTime()
										productApi.assignVendorInventoryAndPromotionalPrices(product)
										store.dispatch('cart/addToCart', product)
										if (router.currentRoute.path === '/checkout') {
											if (product.stock < 1) {
												Vue.toasted.show('Some of your cart item(s) is out of stock')
												router.push({
													path: '/cart',
													query: {
														display_text: 'My Cart'
													}
												})
											}
										}
									}
								})
							}
						}
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		},
		clearCart () {
			return new Promise((resolve, reject) => {
				this.$http.get(url.clearCartUrl)
					.then((res) => {
						resolve(res)
					})
					.catch((e) => {
						reject(e)
					})
			})
		}
	}
})
